<template>
  <span :class="$style.layout">
    <Header />
    <!-- <router-view id="content" :class="$style.content" /> -->
    <router-view v-if="route && route.matched.length" id="content" :class="$style.content" />
<ScrollToTop />

   <CookieBanner
      v-if="route?.meta?.tracking && !(cookieConsent?.value?.accepted)"
    />
    <Footer />
  </span>
</template>

<script>
import { defineComponent, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/AppHeader.vue';
import Footer from '@/components/AppFooter.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import CookieBanner  from '@/components/CookieBanner.vue';
import {
  cookieConsent,
  activateTrackingScripts,
  trackPageView,
  resetPageViewFlag
} from "@/cookieStore";


export default defineComponent({
  components: {
    Header,
    Footer,
    ScrollToTop,
    CookieBanner 
  },
  setup() {
    const route = useRoute();
  watch(
      () => route.fullPath,
      () => {
  
        if (!route.meta?.tracking) return;

        if (!(cookieConsent?.value?.accepted)) return;

   
        activateTrackingScripts(route);
        resetPageViewFlag();
        trackPageView(route.path);
      },
      { immediate: true } 
    );

    return {
      route,
      cookieConsent,
    };
  },
});
</script>

<style lang="scss" module>
@import "./deps.scss";
@import "./_variables.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.layout {
  font-family: 'Inter', 'sans-serif';
  white-space: pre-wrap;
}

.content {
  background-color: #fff;
  width: 100%;

  h1, h2, h3, h4 {
    color: black;
    font-weight: 1000 !important;
  }
}
</style>

